const UrasHome = () => import(/* webpackChunkName: "group-pabx-cadastros-ura" */ '../_views/UrasHome')
const CadastroUra = () => import(/* webpackChunkName: "group-pabx-cadastros-ura" */ '../_views/CadastroUra')
const AtualizarUra = () => import(/* webpackChunkName: "group-pabx-cadastros-ura" */ '../_views/AtualizarUra')

import { permissionsPabx } from '../../../../../utils/permissionsPabx'

export default [
  {
    path: 'uras',
    component: UrasHome,
    meta: { requiresAuth: true, permissions: [...permissionsPabx] },
    name: 'Uras',
  },
  {
    path: 'uras/criar',
    component: CadastroUra,
    meta: { requiresAuth: true, permissions: [...permissionsPabx] },
    name: 'Uras/criar',
  },
  {
    path: 'uras/atualizar/:_id',
    component: AtualizarUra,
    meta: { requiresAuth: true, permissions: [...permissionsPabx] },
    name: 'uras/atualizar',
    props: true,
  },
]
